{
  "title": "Friends",
  "source": "Player's Handbook",
  "levelAndSchool": "Enchantment cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Self",
  "components": "S, M (a small amount of makeup applied to the face as this spell is cast)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "For the duration, you have advantage on all Charisma checks directed at one creature of your choice that isn't hostile toward you. When the spell ends, the creature realizes that you used magic to influence its mood and becomes hostile toward you. A creature prone to violence might attack you. Another creature might seek retribution in other ways (at the DM's discretion), depending on the nature of your interaction with it."
  ],
  "spellLists": ["bard", "eldritch-knight", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
